module.exports = __webpack_public_path__ + "img/NBA_TripleShot.fa9205d5.png";